var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homepage-Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Comment-Button",
    transform: "translate(-1456.000000, -669.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(1456.000000, 669.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#72B6C6",
    cx: 13,
    cy: 13,
    r: 13
  }), /*#__PURE__*/React.createElement("g", {
    id: "thumbs-up-solid-copy",
    transform: "translate(8.000000, 7.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99491122,0.0209801999 C7.57521655,0.137041267 7.95241502,0.701722995 7.83635395,1.28202833 L7.78501925,1.5364699 C7.66672624,2.13239884 7.44799577,2.69931251 7.14221949,3.21489148 L10.3562183,3.21489148 C10.9476833,3.21489148 11.4275512,3.69475935 11.4275512,4.2862244 C11.4275512,4.69913397 11.1931971,5.05847689 10.8494778,5.23703237 C11.0927597,5.43344341 11.2489957,5.7347558 11.2489957,6.07177928 C11.2489957,6.59405408 10.8740292,7.02928308 10.3807696,7.12302471 C10.4789752,7.28595659 10.5347738,7.4756718 10.5347738,7.67877866 C10.5347738,8.15418265 10.2245336,8.55816444 9.79600043,8.69654494 C9.81162403,8.77019908 9.82055181,8.84831711 9.82055181,8.92866708 C9.82055181,9.52013213 9.34068393,10 8.74921888,10 L6.57307388,10 C6.1490046,10 5.73609503,9.87501116 5.38344794,9.64065708 L4.52414966,9.06704758 C3.92822072,8.66976162 3.57110975,8.00017854 3.57110975,7.28372465 L3.57110975,6.42889025 L3.57110975,5.35755733 L3.57110975,4.80180337 C3.57110975,4.15007585 3.86795825,3.53629136 4.37460944,3.12784568 L4.53977327,2.99616101 C5.13123832,2.52298897 5.53522011,1.85786978 5.68252839,1.1168645 L5.73386309,0.862422934 C5.84992415,0.2821176 6.41460588,-0.0950808669 6.99491122,0.0209801999 Z M0.714221949,3.57200245 L2.14266585,3.57200245 C2.53771986,3.57200245 2.8568878,3.89117039 2.8568878,4.2862244 L2.8568878,9.28577805 C2.8568878,9.68083207 2.53771986,10 2.14266585,10 L0.714221949,10 C0.319167934,10 0,9.68083207 0,9.28577805 L0,4.2862244 C0,3.89117039 0.319167934,3.57200245 0.714221949,3.57200245 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.a244e94e64ac1afe8211096d5aed4aec.svg";
export { ForwardRef as ReactComponent };